/* tslint:disable */
/* eslint-disable */
/**
 * Performo API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.6.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function AssetCreateCommandFromJSON(json) {
    return AssetCreateCommandFromJSONTyped(json, false);
}
export function AssetCreateCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'fmRecordId': !exists(json, 'fmRecordId') ? undefined : json['fmRecordId'],
        'fmModId': !exists(json, 'fmModId') ? undefined : json['fmModId'],
        'assetId': !exists(json, 'assetId') ? undefined : json['assetId'],
        'propertyId': !exists(json, 'propertyId') ? undefined : json['propertyId'],
        'assetCode': !exists(json, 'assetCode') ? undefined : json['assetCode'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'type': !exists(json, 'type') ? undefined : json['type'],
        'subtype': !exists(json, 'subtype') ? undefined : json['subtype'],
        '_function': !exists(json, 'function') ? undefined : json['function'],
        'jobType': !exists(json, 'jobType') ? undefined : json['jobType'],
        'location1': !exists(json, 'location1') ? undefined : json['location1'],
        'floor': !exists(json, 'floor') ? undefined : json['floor'],
        'location2': !exists(json, 'location2') ? undefined : json['location2'],
        'location3': !exists(json, 'location3') ? undefined : json['location3'],
        'gps': !exists(json, 'gps') ? undefined : json['gps'],
        'manufacturer': !exists(json, 'manufacturer') ? undefined : json['manufacturer'],
        'replacementDateInput': !exists(json, 'replacementDateInput') ? undefined : (new Date(json['replacementDateInput'])),
        'model': !exists(json, 'model') ? undefined : json['model'],
        'barcode': !exists(json, 'barcode') ? undefined : json['barcode'],
        'notes': !exists(json, 'notes') ? undefined : json['notes'],
        'purchaseDate': !exists(json, 'purchaseDate') ? undefined : (new Date(json['purchaseDate'])),
        'purchasePrice': !exists(json, 'purchasePrice') ? undefined : json['purchasePrice'],
        'serialNum': !exists(json, 'serialNum') ? undefined : json['serialNum'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'vendor': !exists(json, 'vendor') ? undefined : json['vendor'],
        'criticalNum': !exists(json, 'criticalNum') ? undefined : json['criticalNum'],
        'picked': !exists(json, 'picked') ? undefined : json['picked'],
        'installDate': !exists(json, 'installDate') ? undefined : (new Date(json['installDate'])),
        'usefulLife': !exists(json, 'usefulLife') ? undefined : json['usefulLife'],
        'usefulLifeTimeUnit': !exists(json, 'usefulLifeTimeUnit') ? undefined : json['usefulLifeTimeUnit'],
        'replacementCost': !exists(json, 'replacementCost') ? undefined : json['replacementCost'],
        'maintCompany': !exists(json, 'maintCompany') ? undefined : json['maintCompany'],
        'maintContact': !exists(json, 'maintContact') ? undefined : json['maintContact'],
        'maintContractNotes': !exists(json, 'maintContractNotes') ? undefined : json['maintContractNotes'],
        'maintPhoneNum': !exists(json, 'maintPhoneNum') ? undefined : json['maintPhoneNum'],
        'maintFaxNum': !exists(json, 'maintFaxNum') ? undefined : json['maintFaxNum'],
        'maintPagerNum': !exists(json, 'maintPagerNum') ? undefined : json['maintPagerNum'],
        'maintEmailAddress': !exists(json, 'maintEmailAddress') ? undefined : json['maintEmailAddress'],
        'maintCellNum': !exists(json, 'maintCellNum') ? undefined : json['maintCellNum'],
        'maintAgreemtBegin': !exists(json, 'maintAgreemtBegin') ? undefined : (new Date(json['maintAgreemtBegin'])),
        'maintAgreemtEnd': !exists(json, 'maintAgreemtEnd') ? undefined : (new Date(json['maintAgreemtEnd'])),
        'maintAgreemtCost': !exists(json, 'maintAgreemtCost') ? undefined : json['maintAgreemtCost'],
        'maintCostPeriod': !exists(json, 'maintCostPeriod') ? undefined : json['maintCostPeriod'],
        'user1': !exists(json, 'user1') ? undefined : json['user1'],
        'user2': !exists(json, 'user2') ? undefined : json['user2'],
        'user3': !exists(json, 'user3') ? undefined : json['user3'],
        'user4': !exists(json, 'user4') ? undefined : json['user4'],
        'user5': !exists(json, 'user5') ? undefined : json['user5'],
        'user6': !exists(json, 'user6') ? undefined : json['user6'],
        'user7': !exists(json, 'user7') ? undefined : json['user7'],
        'user8': !exists(json, 'user8') ? undefined : json['user8'],
        'user9': !exists(json, 'user9') ? undefined : json['user9'],
        'user10': !exists(json, 'user10') ? undefined : json['user10'],
        'user11': !exists(json, 'user11') ? undefined : json['user11'],
        'user12': !exists(json, 'user12') ? undefined : json['user12'],
        'user13': !exists(json, 'user13') ? undefined : json['user13'],
        'user14': !exists(json, 'user14') ? undefined : json['user14'],
        'user15': !exists(json, 'user15') ? undefined : json['user15'],
        'user16': !exists(json, 'user16') ? undefined : json['user16'],
        'user17': !exists(json, 'user17') ? undefined : json['user17'],
        'user18': !exists(json, 'user18') ? undefined : json['user18'],
        'user19': !exists(json, 'user19') ? undefined : json['user19'],
        'user20': !exists(json, 'user20') ? undefined : json['user20'],
        'createdDate': !exists(json, 'createdDate') ? undefined : (new Date(json['createdDate'])),
        'createdTime': !exists(json, 'createdTime') ? undefined : (new Date(json['createdTime'])),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedTime': !exists(json, 'modifiedTime') ? undefined : (new Date(json['modifiedTime'])),
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : (new Date(json['modifiedDate'])),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
        'createdTimeStamp': !exists(json, 'createdTimeStamp') ? undefined : (new Date(json['createdTimeStamp'])),
        'modifiedTimeStamp': !exists(json, 'modifiedTimeStamp') ? undefined : (new Date(json['modifiedTimeStamp'])),
    };
}
export function AssetCreateCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'fmRecordId': value.fmRecordId,
        'fmModId': value.fmModId,
        'assetId': value.assetId,
        'propertyId': value.propertyId,
        'assetCode': value.assetCode,
        'name': value.name,
        'type': value.type,
        'subtype': value.subtype,
        'function': value._function,
        'jobType': value.jobType,
        'location1': value.location1,
        'floor': value.floor,
        'location2': value.location2,
        'location3': value.location3,
        'gps': value.gps,
        'manufacturer': value.manufacturer,
        'replacementDateInput': value.replacementDateInput === undefined ? undefined : (value.replacementDateInput.toISOString()),
        'model': value.model,
        'barcode': value.barcode,
        'notes': value.notes,
        'purchaseDate': value.purchaseDate === undefined ? undefined : (value.purchaseDate.toISOString()),
        'purchasePrice': value.purchasePrice,
        'serialNum': value.serialNum,
        'status': value.status,
        'vendor': value.vendor,
        'criticalNum': value.criticalNum,
        'picked': value.picked,
        'installDate': value.installDate === undefined ? undefined : (value.installDate.toISOString()),
        'usefulLife': value.usefulLife,
        'usefulLifeTimeUnit': value.usefulLifeTimeUnit,
        'replacementCost': value.replacementCost,
        'maintCompany': value.maintCompany,
        'maintContact': value.maintContact,
        'maintContractNotes': value.maintContractNotes,
        'maintPhoneNum': value.maintPhoneNum,
        'maintFaxNum': value.maintFaxNum,
        'maintPagerNum': value.maintPagerNum,
        'maintEmailAddress': value.maintEmailAddress,
        'maintCellNum': value.maintCellNum,
        'maintAgreemtBegin': value.maintAgreemtBegin === undefined ? undefined : (value.maintAgreemtBegin.toISOString()),
        'maintAgreemtEnd': value.maintAgreemtEnd === undefined ? undefined : (value.maintAgreemtEnd.toISOString()),
        'maintAgreemtCost': value.maintAgreemtCost,
        'maintCostPeriod': value.maintCostPeriod,
        'user1': value.user1,
        'user2': value.user2,
        'user3': value.user3,
        'user4': value.user4,
        'user5': value.user5,
        'user6': value.user6,
        'user7': value.user7,
        'user8': value.user8,
        'user9': value.user9,
        'user10': value.user10,
        'user11': value.user11,
        'user12': value.user12,
        'user13': value.user13,
        'user14': value.user14,
        'user15': value.user15,
        'user16': value.user16,
        'user17': value.user17,
        'user18': value.user18,
        'user19': value.user19,
        'user20': value.user20,
        'createdDate': value.createdDate === undefined ? undefined : (value.createdDate.toISOString()),
        'createdTime': value.createdTime === undefined ? undefined : (value.createdTime.toISOString()),
        'createdBy': value.createdBy,
        'modifiedTime': value.modifiedTime === undefined ? undefined : (value.modifiedTime.toISOString()),
        'modifiedDate': value.modifiedDate === undefined ? undefined : (value.modifiedDate.toISOString()),
        'modifiedBy': value.modifiedBy,
        'createdTimeStamp': value.createdTimeStamp === undefined ? undefined : (value.createdTimeStamp.toISOString()),
        'modifiedTimeStamp': value.modifiedTimeStamp === undefined ? undefined : (value.modifiedTimeStamp.toISOString()),
    };
}
